import { PkButton } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import parseHtmlToReact from 'html-react-parser';
import { memo, useMemo } from 'react';

import type { EditorialContent } from '@cobalt/utilities';
import { stripHtml } from '@utilities/dom';

import * as styles from './styles.module.scss';

const trackingData = {
  primaryBtn: {
    category: 'Click',
    action: 'Ticketing primary action',
    label: 'ticketing',
    name: 'ticketing',
    more: { section_reference: 'ticketing', interaction: 'Ticketing primary action' },
  },
  secondaryBtn: {
    category: 'Click',
    action: 'Ticketing secondary action',
    label: 'ticketing',
    name: 'ticketing',
    more: { section_reference: 'ticketing', interaction: 'Ticketing secondary action' },
  },
};

interface StickyHeaderProps {
  article: EditorialContent;
}

const StickyHeader = ({ article }: StickyHeaderProps) => {
  const button = useMemo(
    () => (article.document?.content || []).filter((elem) => elem._attributes?.['emk-type'].includes('button')).at(0),
    [article.document?.content],
  );
  const listSummary = useMemo(
    () => article.document?._elements?.find((elem) => elem._type === 'ALTERNATE-SUMMARY')?._html,
    [article.document?._elements],
  );

  // Check all sticky elements and get their height
  const top = useMemo(
    () =>
      [
        ...(document.querySelectorAll('.navigation--sticky') ?? []),
        ...(document.querySelectorAll('.affix') ?? []),
      ].reduce((acc, elem) => acc + elem.clientHeight, 0),
    [],
  );

  if (!stripHtml(listSummary) && !button?._text) return null;

  return (
    <div
      className={clsx(styles.ticketingBanner, 'pk-container pk-bg--interaction-compl')}
      pk-theme='light'
      style={{ top }}
    >
      <div className='pk-col pk-col--span-12 pk-d--flex pk-gap--xs pk-gap-sm--l pk-justify-content--between pk-align-items--center'>
        {stripHtml(listSummary) && (
          <div className={styles.ticketingBannerSummary}>{parseHtmlToReact(listSummary ?? '')}</div>
        )}
        {button?._text && (
          <PkButton
            className={clsx(styles.ticketingBannerButton, 'js-tracking-link')}
            linkHref={button._attributes.href}
            linkTarget='_blank'
            width='auto'
            data-tracking={JSON.stringify(trackingData.primaryBtn)}
          >
            {button._text}
          </PkButton>
        )}
      </div>
    </div>
  );
};

export default memo(StickyHeader);
